/* @flow */
import { Container } from 'flux/utils';
import AppTopBar from 'app/components/AppTopBar.jsx';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import React from 'react';
import { rootGroup } from 'entities/RootGroup';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showRecent, hideRecent } from 'reducers/recentMessagesModal';

type State = {
  displayIcon: boolean,
  canAccessAdminConsole: boolean,
  showRCE: boolean,
  showZopim: boolean,
  userName: string,
};

type Props = {
  showingRecent: boolean,
  showRecent: Function,
  hideRecent: Function,
};

class AppTopBarContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [
      CurrentUser,
      ChatStore,
    ];
  }

  static calculateState() {
    const user = CurrentUser.getUser();

    return {
      showRCE: user.isRCE(),
      showZopim: !user.isUnderage(),
      userName: user.getFullName(),
      displayIcon: ChatStore.getChats(rootGroup).length > 0,
    };
  }

  render() {
    const { displayIcon, showRCE, showZopim, userName } = this.state;

    return (
      <AppTopBar
        showRCE={showRCE}
        showZopim={showZopim}
        userName={userName}
        displayIcon={displayIcon}
        showingRecent={this.props.showingRecent}
        showRecent={this.props.showRecent}
        hideRecent={this.props.hideRecent}
      />
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    showingRecent: state.recentMessagesModal.showingRecent,
  };
};

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators({
    showRecent,
    hideRecent,
  }, dispatch);

export const container = Container.create(AppTopBarContainer); // expose for testing
export default connect(mapStateToProps, mapDispatchToProps)(container);



// WEBPACK FOOTER //
// ./src/app/containers/AppTopBarContainer.jsx